export class ApiError extends Error {
  constructor(message, status, code) { super(message); this.name = 'ApiError'; this.status = status; this.code = code; }
}

export async function api(path, options = {}) {
  const { signal, ...rest } = options;
  let response;
  try {
    response = await fetch(`/api${path}`, {
      credentials: 'same-origin',
      ...rest, signal,
      headers: { 'Content-Type': 'application/json', ...(rest.headers || {}) },
      ...(rest.body !== undefined ? { body: JSON.stringify(rest.body) } : {})
    });
  } catch (error) {
    if (error.name === 'AbortError') throw error;
    throw new ApiError('无法连接服务器，请检查网络后重试。', 0, 'NETWORK_ERROR');
  }
  let data;
  try { data = await response.json(); } catch { data = {}; }
  if (!response.ok) {
    if (response.status === 401 && !path.startsWith('/auth/')) window.dispatchEvent(new Event('auth-expired'));
    if (data.error?.code === 'PASSWORD_CHANGE_REQUIRED') window.dispatchEvent(new Event('password-change-required'));
    throw new ApiError(data.error?.message || '请求失败，请重试。', response.status, data.error?.code || 'REQUEST_ERROR');
  }
  return data;
}
